(function (sb) {
	sb.TemplatesLibrary = {};

	var isLoaded = false;
	var createMode = false;
	var editMode = false;
	var templates = [];
	var templateItemTooltip;
	var itemTypes = sb.Constants.TemplateItemTypes;
	var customersOptions = "";

	// --- Layout and Tree operations ---
	function getItemById(itemId) {
		itemId = parseInt(itemId, 10);
		var item;

		var findItem = function (tree, id) {
			for (var n in tree) {
				if (!tree.hasOwnProperty(n)) continue;
				if (typeof tree[n] === "object" && tree[n].item && tree[n].item.id === id) {
					item = tree[n];
					break;
				} else {
					findItem(tree[n].children, id);
				}
			}
		};

		if (!isNaN(itemId)) findItem(templates, itemId);
		return item || null;
	}

	function filterTemplateItem(tree, templateFilter) {
		if (typeof templateFilter !== "object" || templateFilter === null) return true;

		for (var key in templateFilter) {
			if (!templateFilter.hasOwnProperty(key)) continue;
			if (tree.item[key] === templateFilter[key]) return true;
		}

		return false;
	}

	function renderItemHtml(item) {
		var thumbnailSize = "&width=130" + (item.typeId == 5 ? "" : "&height=100");
		var templateType = itemTypes.getTypeText(item.typeId);
		if (templateType === "Report") templateType = "Multiple slides";

		return "<div class='templateItem' data-id='" + item.id + "'>" +
			"<div class='templateThumb templateThumb" + item.typeId + "'>" +
			"<img src='FileHandler.ashx?templateThumbnail=true&tid=" + item.id + (item.sourceProjectId ? "&spid=" + item.sourceProjectId : "") + thumbnailSize + "' />" +
			"</div>" +
			"<div class='templateName' title='" + item.name + "'>" + item.name + "</div>" +
			"<i class='templateType'>" + templateType + "</i>" +
			"</div>";
	}

	function renderTemplatesList(templateFilter) {
		$("#btnLayoutTemplates").show();
		$("#btnDataLayoutTemplates").show();
		$("#btnALlTemplates").show();
		var templatesHtml = "";
		var templateType = $(".selectedLayoutType").attr("id");
		var isEmptyFolder = true;
		var hasLayoutTemplates = false;
		function renderTemplatesHtml(tree) {

			for (var n in tree) {
				if (!tree.hasOwnProperty(n)) continue;
				if (typeof tree[n] == "object" && tree[n] !== null) {
					if (tree[n].item.typeId !== itemTypes.Folder) {
						if (filterTemplateItem(tree[n], templateFilter)) {
							isEmptyFolder = false;
							if (!tree[n].item.isDataTemplate) {
								hasLayoutTemplates = true;
							}
							switch (templateType) {
								case "btnDataLayoutTemplates":
									if (tree[n].item.isDataTemplate)
										templatesHtml += renderItemHtml(tree[n].item);
									break;
								case "btnLayoutTemplates":
									if (!tree[n].item.isDataTemplate)
										templatesHtml += renderItemHtml(tree[n].item);
									break;
								case "btnAllTemplates":
									templatesHtml += renderItemHtml(tree[n].item);
									break;
								default:
									break;
							}
						}
					} else if (typeof tree[n].children === "object" && tree[n].children.length > 0)
						renderTemplatesHtml(tree[n].children);
				}
			}
			if (!hasLayoutTemplates || isEmptyFolder) {
				selectTemplateType('btnDataLayoutTemplates');
				$("#btnLayoutTemplates").hide();
				$("#btnAllTemplates").hide();
			}
			else if (hasLayoutTemplates) {
				selectTemplateType(templateType)
				$("#btnLayoutTemplates").show();
				$("#btnAllTemplates").show();
			}
		}


		renderTemplatesHtml(templates);
		$("#txtTemplateSearch").val('');
		if ((!hasLayoutTemplates || isEmptyFolder) && templateType != 'btnDataLayoutTemplates') {
			renderTemplatesList(templateFilter);
		}
		else
			$("#templatesList").empty().append(templatesHtml);
		if(templateFilter.parentId === 1) {
			selectTemplateType(templateType)
			$("#btnLayoutTemplates").show();
			$("#btnAllTemplates").show();
		}
	}

	function renderFoldersTree(selectedFolderId) {
		var foldersHtml = "";

		function renderFoldersHtml(tree) {
			var labelClassName = "", folderClassName = "";

			for (var n in tree) {
				if (!tree.hasOwnProperty(n)) continue;
				if (typeof tree[n] == "object" && tree[n] !== null) {
					if (tree[n].item.typeId !== itemTypes.Folder) continue;
					labelClassName = "";
					folderClassName = "folder";
					labelClassName += (tree[n].item.parentId == null ? "root" : (tree[n].item.id === selectedFolderId ? "selected" : ""));
					folderClassName += (tree[n].item.path === "1" && tree[n].item.customerId == 0 && tree[n].item.name.indexOf('Dapresy') > -1 ? " folder-dapresy" : "");
					folderClassName += (tree[n].item.editable === true ? " folder-sortable" : "");
					foldersHtml += "<li class='" + folderClassName + "'>" +
						"<input type='checkbox' id='templateFolder" + tree[n].item.id + "' />" +
						"<label for='templateFolder" + tree[n].item.id + "'" +
						(tree[n].item.customerName && tree[n].item.customerName.length > 0 ? " title='" + tree[n].item.customerName + "'" : "") + ">" +
						"<span data-folder-id='" + tree[n].item.id + "' " +
						"class='" + labelClassName + "'" + ">" +
						(tree[n].item.name ? HTMLHelpers.htmlEncode(tree[n].item.name) : "") + "</span></label>";
					foldersHtml += "<ul>";
					if (typeof tree[n].children === "object" && tree[n].children.length > 0) {
						renderFoldersHtml(tree[n].children);
					}
					foldersHtml += "</ul>";
					foldersHtml += "</li>";
				}
			}
		}

		renderFoldersHtml(templates);
		$("#templateFoldersTree").empty().append("<ul>" + foldersHtml + "</ul>");

		$("#templateFoldersTree ul").each(function(index) {
			if (index === 0)
				$(this).find("> li > input").attr("checked", "checked");
			else if ($(this).is(":empty"))
				$(this).siblings("input").attr("disabled", "disabled").end().remove();
			else if ($(this).find('span.selected').length > 0)
				$(this).siblings("input").attr("checked", "checked");
		});

		$("#templateFoldersTree ul ul").sortable({
			items: "> li.folder-sortable",
			helper: "clone",
			delay: 300,
			update: function () {
				var orderedFolders = [];
				$(this).find(" > li").each(function () {
					var id = parseInt($("span", this).attr("data-folder-id"), 10);
					if (getItemById(id).item.editable)
						orderedFolders.push(id);
				});
				Helpers.perfJSonCall({
					method: "UpdateTemplateSortOrder",
					data: { orderedTemplatesIds: orderedFolders }
				});
			}
		});
	}

	function searchTemplates() {
		var keyword = $.trim($("#txtTemplateSearch").val());
		var selectedFolderId = parseInt($("#templateFoldersTree span.selected").attr("data-folder-id"), 10);
		var selectedFolder = getItemById(selectedFolderId);
		var tree = selectedFolder && selectedFolder.children ? selectedFolder.children : templates;
		var templatesHtml = "";
		var templateType = $(".selectedLayoutType").attr("id");

		var searchItems = function(tree, keyword) {
			for (var n in tree) {
				if (!tree.hasOwnProperty(n)) continue;
				if (typeof tree[n] === "object" && tree[n].item) {
					var item = tree[n].item;
					if (item.name.toLowerCase().indexOf(keyword.toLowerCase()) > -1 ||
						(item.tags && item.tags.toLowerCase().indexOf(keyword.toLowerCase()) > -1)) {
						if (item.typeId !== itemTypes.Folder) {
							switch (templateType) {
								case "btnDataLayoutTemplates":
									if (tree[n].item.isDataTemplate) {
										templatesHtml += renderItemHtml(tree[n].item);
										$("#templateFoldersTree span[data-folder-id=\"" + item.parentId + "\"]").addClass("nonempty");
									}
									break;
								case "btnLayoutTemplates":
									if (!tree[n].item.isDataTemplate) {
										templatesHtml += renderItemHtml(tree[n].item);
										$("#templateFoldersTree span[data-folder-id=\"" + item.parentId + "\"]").addClass("nonempty");
									}
									break;
								case "btnAllTemplates":
									templatesHtml += renderItemHtml(tree[n].item);
									$("#templateFoldersTree span[data-folder-id=\"" + item.parentId + "\"]").addClass("nonempty");
									break;
								default:
									break;
							}
						} else {
							$("#templateFoldersTree span[data-folder-id=\""+ item.id +"\"]").addClass("nonempty");
						}
					}
				}
				if (typeof tree[n] === "object" && tree[n].children)
					searchItems(tree[n].children, keyword);
			}
		};

		$("#templateFoldersTree span.nonempty").removeClass("nonempty");

		if (keyword === "" && selectedFolder) {
			renderTemplatesList({ parentId: selectedFolder.item.id });
		}

		if(keyword.length > 0) {
			searchItems(tree, keyword);
			$("#templatesList").html(templatesHtml);
		}
	}

	function buildTree(templatesTree) {
		templates = templatesTree;
		var defaultFolderId = -1;
		for (var i = 0; i < templates[0].children.length; i++) {
			var child = templates[0].children[i].item;
			if (child.typeId == itemTypes.Folder) {
				defaultFolderId = child.id;
				break;
			}
		}

		renderFoldersTree(defaultFolderId);
		if (defaultFolderId > -1)
			renderTemplatesList({ parentId: defaultFolderId });
	}

	function bindEvents() {
		// Folder
		$("#templateFoldersTree").delegate("span", "click", function (evt) {
			$("#templateFoldersTree span.selected").removeClass("selected");
			$("#templatesFolderName").trigger('blur');
			$(this).addClass("selected");
			var changeFolder = function () {
				editMode = false;
				searchTemplates();
				showHideOperations();
				showFolderTools();
			};
			discardEditsConfirmation(changeFolder);

			$(this).closest(".folder").find("> input").attr("checked", true);

			evt.preventDefault();
			evt.stopPropagation();
		}).delegate(".btnMoveFolderFrom", "click", "Folder", moveItemFrom)
			.delegate(".btnMoveFolderTo", "click", "Folder", moveItemTo)
			.delegate(".btnMoveTemplateTo", "click", "Template", moveItemTo)
			.delegate(".btnRenameFolder", "click", renameFolder)
			.delegate(".btnDeleteFolder", "click", deleteFolder);

		// Template
		$("#templatesList")
			.bind("click", function(evt) {
				if (evt.target.id !== "templatesList") return;
				var removeSelected = function() {
					$("#templatesList .templateItem.selected").removeClass("selected");
					showHideOperations();
				};
				discardEditsConfirmation(removeSelected);
			}).delegate(".templateItem", "click", function(evt) {
				var templateEl = $(this);
				var selectTemplate = function() {
					$("#templatesList .templateItem.selected").removeClass("selected");
					templateEl.addClass("selected");
					showHideOperations();
				};
				discardEditsConfirmation(selectTemplate);
			})
			.delegate(".templateItem", "dblclick", function(evt) {
				discardEditsConfirmation(importTemplate);
			})
			.delegate(".templateItem", "mouseenter", showTemplateToolsHandler)
			.delegate(".templateItem", "mouseleave", hideTemplateToolsHanlder)
			.delegate(".btnMoveTemplate", "click", "Template", moveItemFrom)
			.delegate(".btnDeleteTemplate", "click", deleteTemplateHandler)
			.delegate(".btnEditTemplateInfo", "click", editTemplateInfoHandler)
			.delegate(".btnThumbnailZoom", "click", zoomThumbnailHandler);

		// Search
		$("#txtTemplateSearch").bind("keyup", Helpers.debounce(searchTemplates, 400));

		$("#txtTemplateName").bind("keyup", Helpers.debounce(validateTemplate, 400));
		$("#txtTemplateName").bind("change", validateTemplate);
	}

	function getTemplateData(templateId, save) {
		Helpers.perfJSonCall({
			data: { templateId: templateId },
			method: "GetTemplateSavedContent",
			successCallback: function (result) {
				if (result.length === 0)
					hideSavedDataSection();
				else
					populateDataSectionEdit(result);

			},
			failedCallback: function () {
				Storyboard.LayoutControls.showMessage(locale.get("Unable to fetch template data."));
			},
			fixCasing: true
		});

	}

	function hideSavedDataSection() {
		$("#txtTemplateCalcType").empty();
		$("#txtTemplateQA").empty();
		$("#txtTemplateFilters").empty();
		$("#templatesLibraryNewItemDataContent").hide();
	}

	function showHideOperations() {
		var selectedTemplateEl = $("#templatesList .templateItem.selected");
		var selectedTemplateId = parseInt(selectedTemplateEl.attr("data-id"), 10);
		var selectedTemplate = getItemById(selectedTemplateId);
		var selected = selectedTemplate === null ? false : true;

		var selectedFolder = getSelectedFolderSettings();

		var typeId = null;
		if (createMode)
			typeId = parseInt($("#hidTemplateTypeId").val(), 10);
		else if (selected)
			typeId = selectedTemplate.item.typeId;

		hideTemplateInfoTooltip();

		$("#btnNewFolder").toggle(selectedFolder && (selectedFolder.editable || selectedFolder.parentId === null));
		$("#btnSaveNewTemplate").toggle(createMode && !selected);
		$("#btnUpdateTemplate").toggle((createMode || editMode) && selected);
		$("#btnImportTemplate, #chbUseSourcePosition").toggle(!createMode && !editMode).attr("disabled", !selected);
		$(".hdUseSourcePosition").toggle(!createMode && !editMode && selected && (typeId == itemTypes.Element || typeId == itemTypes.Group));

		if (!createMode && !editMode && selected)
			$("#chbUseSourcePosition").attr("checked", selectedTemplate.item.useSourcePosition);

		$("#templatesHolder .templatesLibraryNewItem").toggle(createMode || editMode);
		$("#templatesHolder .templatesLibraryItemsList").css('max-height', (createMode || editMode ? '270px' : ''));
		$('#templatesHolder .templatesLibraryNewItem .Message').remove();
		$("#templateFoldersTree .templateFolderMenu").remove();

		if (createMode || editMode) {
			$("#btnLayoutTemplates").hide();
			$("#btnAllTemplates").hide();
			if (editMode)
				getTemplateData(selectedTemplateId, false);
			if (selected) {
				$("#templatesLibraryNewItemTitle").text(locale.get("Update Template"));
				$("#txtTemplateName").val(HTMLHelpers.htmlDecode(selectedTemplate.item.name));
				$("#txtTemplateTags").val(HTMLHelpers.htmlDecode(selectedTemplate.item.tags));
				$("#txtTemplateDescription").val(HTMLHelpers.htmlDecode(selectedTemplate.item.description));
				$("#txtTemplateGoodFor").val(HTMLHelpers.htmlDecode(selectedTemplate.item.goodFor));
				$("#chbDefaultUseSourcePosition").attr("checked", selectedTemplate.item.useSourcePosition);
				if (!selectedTemplate.item.isDataTemplate) {
					$("#btnLayoutTemplates").show();
					$("#btnDataLayoutTemplates").hide();
				}
			} else
				$("#templatesLibraryNewItemTitle").text(locale.get("New "+ itemTypes.getTypeText(typeId) +" Template"));

			$("#chbDefaultUseSourcePosition").closest(".cf").toggle(typeId == itemTypes.Element || typeId == itemTypes.Group);

			$("#txtTemplateName").focus();
			validateTemplate();
		}
	}

	function resetSelections() {
		$("#templatesList .templateItem.selected").removeClass("selected");
		$("#txtTemplateSearch").val("");
		searchTemplates();
	}

	function validateTemplate() {
		var selectedTemplateId = $("#templatesList .templateItem.selected").attr("data-id");
		var selectedTemplate = getItemById(selectedTemplateId);
		var selectedFolder = getSelectedFolderSettings();
		var validName = $("#txtTemplateName").val().length > 0;

		$("#btnSaveNewTemplate").attr("disabled", !(validName && selectedFolder && selectedFolder.editable));
		$("#btnUpdateTemplate").attr("disabled",  !(validName && selectedTemplate && selectedTemplate.item.editable));

		if (selectedFolder && !selectedFolder.editable)
			showValidationMessage('You do not have access right to save into the selected folder');

		if (selectedTemplate && !selectedTemplate.item.editable)
			showValidationMessage('You do not have access rights to update this template');
	}

	function showValidationMessage(message) {
		$('#templatesHolder .templatesLibraryNewItem .Message').remove();
		if (message) $('#templatesHolder .templatesLibraryNewItem').append('<div class="Message Message-error">'+ message +'</div>');
	}

	function discardEditsConfirmation(continueCallback) {
		if (!editMode) {
			if (typeof continueCallback === 'function') continueCallback();
			return true;
		}

		var selectedTemplateEl = $("#templatesList .templateItem.selected");
		var selectedTemplateId = parseInt(selectedTemplateEl.attr("data-id"), 10);
		var selectedTemplate = getItemById(selectedTemplateId);

		var discardConfirmed = function() {
			editMode = false;
			if (typeof continueCallback === 'function') continueCallback();
		};

		hideTemplateInfoTooltip();

		if (selectedTemplate) {
			var template = selectedTemplate.item;
			if ((template.name === $("#txtTemplateName").val()) &&
				(template.tags === $("#txtTemplateTags").val()) &&
				(template.description === $("#txtTemplateDescription").val()) &&
				(template.goodFor === $("#txtTemplateGoodFor").val())) {

				discardConfirmed();
			} else {
				new DUIwindow2({
					closeButton: false,
					width: 320,
					height: 50,
					html: "You have made template changes which are unsaved. <br>Do you want to save the changes?",
					buttons: [
						{ text: "Cancel", onClick: discardConfirmed },
						{ text: "Save", focused: true, onClick: saveTemplateContent }
					]
				});
			}
		} else {
			discardConfirmed();
		}
	}

	function loadTemplatesTree() {
		if (!isLoaded)
			Helpers.perfJSonCall({
				method: "GetTemplatesTree",
				message: "Loading templates...",
				successCallback: function (templatesTree) {
					isLoaded = true;
					buildTree(templatesTree);
					showHideOperations();
					bindEvents();
				},
				failedCallback: function () {
					Storyboard.LayoutControls.showMessage(locale.get("Unable to load templates."));
				},
				fixCasing: true
			});
	}

	function setupPanel() {
		loadTemplatesTree();
		resetSelections();
		showHideOperations();
		Storyboard.GuiEvents.showTemplatesPanel();
	}

	// --- end Layout and Tree operations ---

	// --- Common item operations

	function removeItemFromTree(itemId) {
		itemId = parseInt(itemId, 10);
		var removedItem = [];

		var removeItemById = function (tree, id) {
			for (var i = 0; i < tree.length; i++)
				if (tree[i].item && tree[i].item.id === id) {
					removedItem = tree.splice(i, 1);
					break;
				} else {
					removeItemById(tree[i].children, id);
				}
		};

		if (!isNaN(itemId)) removeItemById(templates, itemId);
		return removedItem.length > 0 ? removedItem[0] : null;
	}

	function deleteItem(itemId) {
		var itemObject = getItemById(itemId);
		if (!itemObject) return;

		Helpers.perfJSonCall({
			data: { itemId: itemId },
			method: "DeleteTemplateItem",
			successCallback: function() {
				if (itemObject.item.typeId === itemTypes.Folder) { // Folder deleted
					var folder = removeItemFromTree(itemId);
					renderFoldersTree(folder.item.parentId);
					renderTemplatesList({ parentId: folder.item.parentId });
					showHideOperations();
					$("#templateFoldersTree #templateFolder" + folder.item.parentId).attr("checked", true);
				} else {
					var template = removeItemFromTree(itemId);
					renderTemplatesList({ parentId: template.item.parentId });
					showHideOperations();
				}
			},
			failedCallback: function() {
				Storyboard.LayoutControls.showMessage(locale.get("Unable to delete item."));
			},
			fixCasing: true
		});
	}

	// --- end Common item operations

	// --- Folders operations  ---

	function getSelectedFolderSettings() {
		var folderEl = $("#templateFoldersTree span.selected");
		var folderId = folderEl.attr("data-folder-id");
		var folder = getItemById(folderId);

		return folder ? folder.item : null;
	}

	function showFolderTools() {
		$("#templateFoldersTree .templateFolderMenu").remove();

		var selectedFolder = getSelectedFolderSettings();
		if (!selectedFolder.editable)
			return;

		var menuHtml =
			"<div class='templateFolderMenu'>" +
			"<button type='button' class='btnMoveFolderFrom DUIButtonIcon' title='Move Folder'>" +
			"<i class='DUI-icon DUI-icon-shortcuts'></i>" +
			"</button>" +
			"<button type='button' class='btnRenameFolder DUIButtonIcon' title='Rename Folder'>" +
			"<i class='DUI-icon DUI-icon-edit'></i>" +
			"</button>" +
			"<button type='button' class='btnDeleteFolder DUIButtonIcon' title='Delete Folder'>" +
			"<i class='DUI-icon DUI-icon-trash'></i>" +
			"</button>" +
			"</div>";

		$("#templateFoldersTree ul ul .selected").append(menuHtml);
	}

	function saveFolder(folderToSave, parentFolderId) {
		var parentFolder = getItemById(parentFolderId);
		if (!parentFolder) return;

		folderToSave.parentId = parentFolder.item.id;
		folderToSave.path = (parentFolder.item.path.length > 0 ? parentFolder.item.path + "-" : "") + parentFolder.item.id;
		folderToSave.typeId = itemTypes.Folder;

		Helpers.perfJSonCall({
			data: { item: folderToSave },
			method: "SaveTemplateItem",
			successCallback: function (savedFolderItem) {
				if (folderToSave.id == 0) { // just saved a new one
					parentFolder.children.push({ item: savedFolderItem, children: [] });
				}
				renderFoldersTree(savedFolderItem.id);
				renderTemplatesList({ parentId: savedFolderItem.id });
			},
			failedCallback: function () {
				Storyboard.LayoutControls.showMessage(locale.get("Unable to save item."));
			},
			fixCasing: true
		});
	}

	function getContent(itemId, itemType, save, templateId) {
		Helpers.perfJSonCall({
			data: { elementItemId: itemId, elementItemType: itemType },
			method: "GetTemplateData",
			successCallback: function (result) {
				if (save)
					saveDataContent(templateId, result);
				else
					populateDataSection(result);
			},
			failedCallback: function () {
				Storyboard.LayoutControls.showMessage(locale.get("Unable to load object content."));
			},
			fixCasing: true
		});
	}

	function saveDataContent(templateId, result) {
		if ($('#templatesLibraryNewItemDataContent')) {
			var data = [];
			var element;
			if (result.length === 1 && result[0] === null) {
				element = {
					templateId: templateId,
					type: 'noData',
					data: null,
					dataGroupId: null,
					isWizard: true
				};
				data.push(element);
			}
			else
				for (var i = 0; i < result.length; i++) {
					element = {
						templateId: templateId,
						type: result[i].item1,
						data: result[i].item2 + result[i].item3,
						dataGroupId: result[i].item4,
						isWizard: result[i].item5
					};
					data.push(element);
				}

			Helpers.perfJSonCall({
				data: { data: data },
				method: "SaveTemplateData",
				failedCallback: function () {
					Storyboard.LayoutControls.showMessage(locale.get("Unable to save object content."));
				},
				fixCasing: true
			});
		}
	}

	function loadCustomers(callback) {
		Helpers.perfJSonCall({
			method: "GetCustomersList",
			successCallback: function (customersList) {
				if (customersList && customersList.length > 0) {
					customersOptions += "<option value='none' selected='selected'>Please select customer</option>";
					$(customersList).each(function () {
						customersOptions += "<option value='" + this.item1 + "'>" + this.item2 + "</option>";
					});
				} else customersOptions = "none";
				if (callback)
					callback();
			},
			failedCallback: function () {
				Storyboard.LayoutControls.showMessage(locale.get("Unable to check customer access."));
			},
			fixCasing: true
		});
	}

	function chooseTemplateType(type) {
		selectTemplateType(type);
		searchTemplates();
	}

	function selectTemplateType(type) {
		$("#btnDataLayoutTemplates").removeClass("selectedLayoutType");
		$("#btnLayoutTemplates").removeClass("selectedLayoutType");
		$("#btnAllTemplates").removeClass("selectedLayoutType");
		switch (type) {
			case 'btnDataLayoutTemplates':
				$("#btnDataLayoutTemplates").addClass("selectedLayoutType");
				break;
			case 'btnLayoutTemplates':
				$("#btnLayoutTemplates").addClass("selectedLayoutType");
				break;
			case 'btnAllTemplates':
				$("#btnAllTemplates").addClass("selectedLayoutType");
				break;
			default:
				break;
		}
	}

	function addFolder() {
		var parentFolderEl = $("#templateFoldersTree span.selected");
		var parentFolderId = parentFolderEl.attr("data-folder-id");
		var parentFolder = getItemById(parentFolderId);
		var newFolder = { id: 0, customerId: 0, editable: true };

		function saveNewFolder() {
			$("#templateFoldersTree #templateFolder" + parentFolderId).attr("checked", true);
			if (parentFolderEl.parent().next("ul").length > 0)
				parentFolderEl.parent().next("ul").append("<li class='folder'><label><span><input id='templatesFolderName' class='settingControlFull textbox'/></span></label></li>");
			else
				parentFolderEl.after("<ul><li class='folder'><label><span><input id='templatesFolderName' class='settingControlFull textbox'/></span></label></li></ul>");

			$("#templatesFolderName").focus()
				.bind("click", function () { return false; })
				.bind("focusout", function () {
					var folderName = $.trim(this.value);

					if (!folderName.length)
						$(this).closest('li').remove();
					else {
						newFolder.name = folderName;
						newFolder.sortOrder = $(this).closest("li").index();
						saveFolder(newFolder, parentFolderId);
					}
				}).bind("keypress", function (evt) {
					if (evt.keyCode === 13)
						$(this).blur();
				});
		}

		// when adding new folder to root: get customers list, we need it for super admins
		if (!customersOptions || customersOptions == "") {
			loadCustomers(addFolder);
			return;
		} else if (!parentFolder.item.parentId && customersOptions != "none") {
			var html = "<select id='ddlTemplateFolderCustomer' class='settingControl'>" + customersOptions + "</select>";
			var customerId = "none";

			new DUIwindow2({
				width: 400,
				padding: 36,
				buttonsHeight: 50,
				buttons: [{
					text: locale.get("Cancel"),
					onClick: function () {
						return false;
					}
				},
				{
					text: locale.get("OK"),
					focused: true,
					onClick: function (event) {
						customerId = $("#ddlTemplateFolderCustomer option:selected").val();
						var customerName = $("#ddlTemplateFolderCustomer option:selected").text();

						if (customerId == "none")
							event.stopPropagation();
						else {
							newFolder.customerId = customerId;
							newFolder.customerName = customerName;
							saveNewFolder();
						}
					}
				}],
				html: html,
				modal: true,
				preWrapSpace: false
			});
		} else saveNewFolder();
	}

	function renameFolder(evt) {
		var folderEl = $("#templateFoldersTree span.selected");
		var folderId = folderEl.attr("data-folder-id");
		var folderName = folderEl.text();

		var renameElement = "<input id='templatesFolderName' class='settingControlFull textbox' value='' />";
		folderEl.empty().append(renameElement);
		$("#templatesFolderName").val(folderName)

		$("#templatesFolderName").focus()
			.bind("click", function () { return false; })
			.bind("focusout", function() {
				var newFolderName = $.trim(this.value);

				if (!newFolderName.length || newFolderName === folderName) {
					$(this).parent().html(HTMLHelpers.htmlEncode(folderName));
				}
				else {
					var folder = getItemById(folderId).item;
					folder.name = newFolderName;
					$(this).parent().html(HTMLHelpers.htmlEncode(newFolderName));
					saveFolder(folder, folder.parentId);
				}
			}).bind("keypress", function(evt) {
				if(evt.keyCode === 13)
					$(this).blur();
			});

		evt.preventDefault();
		evt.stopPropagation();
	}

	function moveItem(item, newParentId) {
		Helpers.perfJSonCall({
			data: { item: item, newParentId: newParentId },
			method: "MoveTemplateItem",
			successCallback: function (newParentSubTree) {
				// no need to rebuild the whole tree, just old and new parent nodes
				removeItemFromTree(item.id);
				renderFoldersTree(item.parentId);
				renderTemplatesList({ parentId: item.parentId });

				var newParent = getItemById(newParentId);
				newParent.children = newParentSubTree;
				renderFoldersTree(newParentId);
				renderTemplatesList({ parentId: newParentId });
				showFolderTools();
			},
			failedCallback: function () {
				Storyboard.LayoutControls.showMessage(locale.get("Unable to move item."));
			},
			fixCasing: true
		});
	}

	function moveItemTo(evt) {
		var itemId, item, message;
		var newParentEl = $(this).closest("span");
		var newParentId = parseInt(newParentEl.attr("data-folder-id"), 10);
		var newParentName = newParentEl.text();

		if (evt.data === "Folder") {
			itemId = $("#templateFoldersTree span.selected").attr("data-folder-id");
			item = getItemById(itemId);
			message = "Do you really want to move <b>" + item.item.name + "</b><br>" +
				"folder including all templates and sub folders to <b>" + HTMLHelpers.htmlEncode(newParentName) + "</b>?";
		}
		else if (evt.data === "Template") {
			itemId = $("#templatesList .templateItem.selected").attr("data-id");
			item = getItemById(itemId);
			message = "Do you really want to move <b>" + HTMLHelpers.htmlEncode(item.item.name) + "</b> template<br>" +
				"to <b>" + HTMLHelpers.htmlEncode(newParentName) + "</b> folder?";
		} else {
			renderFoldersTree();
			return;
		}

		var confirmationDialog = new DUIwindow2({
			closeButton: false,
			width: 400,
			height: 50,
			html: message,
			buttons: [{
				text: "Cancel",
				onClick: function () {
					showFolderTools();
					confirmationDialog.Close();
				}
			},{
				text: "Move",
				focused: true,
				onClick: function () {
					moveItem(item.item, newParentId);
				}
			}
			]
		});

		evt.preventDefault();
		evt.stopPropagation();
	}

	function moveItemFrom(evt) {
		var selectedItem, selectedFolder, moveButtonClass;

		if (evt.data === "Folder") {
			moveButtonClass = 'btnMoveFolderTo';
			selectedItem = getSelectedFolderSettings();
			selectedFolder = $("#templateFoldersTree span.selected").closest(".folder").get(0);
		} else if (evt.data === "Template"){
			moveButtonClass = 'btnMoveTemplateTo';
			$("#templatesList .templateItem.selected").removeClass("selected");
			var itemId = $(this).closest(".templateItem").addClass("selected").attr("data-id");
			selectedItem = getItemById(itemId).item;
		} else {
			return;
		}

		var menuHtml = "<div class='templateFolderMenu'>" +
			"<button type='button' class='"+ moveButtonClass +" DUIButtonIcon' title='Move into this folder'>" +
			"<i class='DUI-icon DUI-icon-shortcuts'></i>" +
			"</button>" +
			"</div>";

		$("#templateFoldersTree span.selected .templateFolderMenu").remove();
		$("#templateFoldersTree span:not(.selected)")
			.filter(function() {
				var folderId = parseInt($(this).attr("data-folder-id"), 10);
				var item = getItemById(folderId).item;

				if (evt.data == "Folder") {
					return  !$.contains(selectedFolder, this) &&
						item.id != selectedItem.parentId &&
						(item.customerId == selectedItem.customerId || item.parentId == null);
				} else {
					return  item.id != selectedItem.parentId &&
						item.customerId == selectedItem.customerId &&
						item.parentId != null;
				}
			}).append(menuHtml);

		evt.preventDefault();
		evt.stopPropagation();
	}

	function deleteFolder() {
		var selectedFolderId = $("#templateFoldersTree span.selected").attr("data-folder-id");

		new DUIwindow2({
			closeButton: false,
			width: 380,
			height: 50,
			html: "Do you really want to delete this folder? <br>All templates and subfolders will be permanently deleted.",
			buttons: [
				{ text: "Cancel", closeWindow: true },
				{ text: "Delete", focused: true, onClick: function () { deleteItem(selectedFolderId); } }
			]
		});
	}

	// --- end Folders operations  ---

	// --- Template operations  ---

	function saveTemplate(template) {
		$("#btnUpdateTemplate, #btnSaveNewTemplate").attr("disabled", "disabled");

		var templateElements = [];
		var templateSlides = [];
		var typeId = createMode ? parseInt($("#hidTemplateTypeId").val(), 10) : template.typeId;

		if (createMode)
			switch (typeId) {
				case itemTypes.Element:
					var elem = Storyboard.LayoutDesigner.getLayoutElementByGuid($("#hidElementGuid").val());
					$(".layoutElement[guid='" + $("#hidElementGuid").val() + "']").removeClass("ui-selected");
					if (elem)
						templateElements.push(elem);
					break;

				case itemTypes.Group:
					var groupId = Storyboard.LayoutDesigner.selectedGroupId;
					if (groupId <= 0)
						break;

					templateElements = Storyboard.LayoutDesigner.getLayoutElementsGroup(groupId).layoutElements;
					break;

				case itemTypes.Slide:
					var currentPageNo = Storyboard.LayoutDesigner.getCurrentPageNo();
					var layoutElements = Storyboard.LayoutDesigner.getLayoutElements();

					templateSlides.push(Storyboard.LayoutDesigner.getCurrentSlide());
					templateElements = $.grep(layoutElements, function(le) {
						return Helpers.getLayoutElementSlideIndex(le) == currentPageNo;
					});
					break;

				case itemTypes.BackgroundSlide:
					var bgSlide = Storyboard.LayoutDesigner.getBackgroundSlide();
					templateSlides.push(bgSlide);
					templateElements = Storyboard.LayoutDesigner.getLayoutElementsBySlide(bgSlide);
					break;

				case itemTypes.Report:
					templateSlides = Storyboard.LayoutDesigner.getLayoutSlides();
					templateElements = Storyboard.LayoutDesigner.getLayoutElements();
					break;
			}

		// if there are any elements: save new template or update existing, overwriting template file
		// otherwise if template exists its info will be updated with no changes done to template file
		if (templateElements.length > 0 || template.id > 0) {
			template.typeId = typeId;

			// to improve thumbnail generation perfomance: pass content (Charts, SimpleTables, DynamicIcons)
			for (var i = 0; i < templateElements.length; i++) {
				var leItemTypes = Storyboard.Constants.itemTypes;
				var contentItem = Storyboard.LayoutDesigner.getElementItemByType(leItemTypes.CHART, leItemTypes.SIMPLETABLE, leItemTypes.DYNAMICICONSHAPE, templateElements[i]);
				if (contentItem) {
					var $leItem = $(".layoutElementItem[guid='" + contentItem.guid + "']");
					switch (contentItem.itemType) {
						case leItemTypes.CHART:
							if ($(".highcharts-container", $leItem).length > 0)
								contentItem.content = $($leItem).highcharts().getSVG();
							break;
						default:
							contentItem.content = $(".layoutElementItem[guid='" + contentItem.guid + "']")[0].innerHTML;
							break;
					}
				}
			}

			$("#templatesHolder").addClass("DUISetupDisabledOverlay");

			Helpers.perfJSonCall({
				data: {
					template: template,
					layoutElements: templateElements,
					settings: GeneralSettings.getSelectedSettings(),
					hFilters: Storyboard.HFilterLayout.getSelectedIds("#hfilterTree"),
					layoutSlides: templateSlides
				},
				method: "SaveTemplateContent",
				successCallback: function (savedTemplateItem) {
					if (!template.id || template.id < 1) {
						// it was a new template, add option
						var folder = getItemById(savedTemplateItem.parentId);
						folder.children.push({ item: savedTemplateItem, children: [] });
						for (var i = 0; i < templateElements.length; i++) {
							getContent(templateElements[i].layoutElementItems[0].elementItemId, templateElements[i].layoutElementItems[0].itemType, true, savedTemplateItem.id);
						}
					} else {

						// overwrite template item
						var templateObject = getItemById(savedTemplateItem.id);
						templateObject.item = savedTemplateItem;
					}

					savedTemplateItem.editable = true;
					createMode = false;
					editMode = false;
					renderTemplatesList({ parentId: savedTemplateItem.parentId });

					var templatesList = $("#templatesList");
					var templateItem = $("#templatesList .templateItem[data-id=" + savedTemplateItem.id + "]").addClass("selected");
					var scroll = templatesList.scrollTop() +
						(templateItem.position().top - templatesList.position().top) -
						(templatesList.height() / 2) + (templateItem.height() / 2);

					templatesList.scrollTop(scroll);
					showHideOperations();
					$("#templatesHolder").removeClass("DUISetupDisabledOverlay");
				},
				failedCallback: function() {
					$("#templatesHolder").removeClass("DUISetupDisabledOverlay");
					Storyboard.LayoutControls.showMessage(locale.get("Unable to save template."));
				},
				message: "Saving template...",
				fixCasing: true
			});
		}
	}

	function saveTemplateContent() {
		var selectedFolderId = parseInt($("#templateFoldersTree span.selected").attr("data-folder-id"), 10);
		var selectedFolder = getItemById(selectedFolderId);

		var selectedTemplateId = $("#templatesList .templateItem.selected").attr("data-id");
		var selectedTemplate = getItemById(selectedTemplateId);
		if (!selectedFolder && !selectedTemplate) return;

		var template;

		if (selectedTemplate)
			template = selectedTemplate.item;
		else {
			template = {
				id: 0,
				path: (selectedFolder.item.path.length > 0 ? selectedFolder.item.path + "-" : "") + selectedFolder.item.id,
				parentId: selectedFolder.item.id,
				isDataTemplate: true
			};
		}

		template.name = HTMLHelpers.htmlEncode($("#txtTemplateName").val());
		template.description = HTMLHelpers.htmlEncode($("#txtTemplateDescription").val());
		template.goodFor = HTMLHelpers.htmlEncode($("#txtTemplateGoodFor").val());
		template.tags = HTMLHelpers.htmlEncode($("#txtTemplateTags").val());
		template.useSourcePosition = $("#chbDefaultUseSourcePosition").is(":checked");

		if (selectedTemplate && parseInt($("#hidTemplateTypeId").val(), 10) > 0) {
			var selectedInfo = selectedTemplate.item.name.length > 0 ? " (" + selectedTemplate.item.name + ")" : "";
			new DUIwindow2({
				closeButton: false,
				width: 380,
				height: 50,
				html: "Do you really want to overwrite this template" + selectedInfo + "?",
				buttons: [
					{ text: "Cancel", closeWindow: true },
					{ text: "Overwrite", focused: true, onClick: function () { saveTemplate(template); } }
				]
			});
		}
		else
			saveTemplate(template);
	}

	function populateDataSection(result) {
		$("#txtTemplateQA").empty();
		$("#txtTemplateFilters").empty();
		$("#txtTemplateCalcType").empty();
		if (result.length === 1 && result[0] === null) {
			$("#txtTemplateQA").append('<br/><li class="no-data">No data selected</li>');
		}
		else if (result.some(r => !r.item5)) {
			$("#txtTemplateQA").append('<li>Multiple</li>');
			$("#txtTemplateFilters").append('<li>Multiple</li>');
			$("#txtTemplateCalcType").append('<li>Multiple</li>');
		}
		else
			for (var i = 0; i < result.length; i++) {
				if (result[i].item1.includes("QnA") || result[i].item1.includes("QA"))
					$("#txtTemplateQA").append('<li>' + result[i].item2 + result[i].item3 + '</li>');
				else if (result[i].item1.includes("Filter"))
					$("#txtTemplateFilters").append('<li>' + result[i].item2 + result[i].item3 + '</li>');
				else if (result[i].item1.includes("Calc"))
					$("#txtTemplateCalcType").append('<li>' + result[i].item2 + '</li>');
			}
	}

	function populateDataSectionEdit(result) {
		$("#templatesLibraryNewItemDataContent").show();
		$("#txtTemplateQA").empty();
		$("#txtTemplateFilters").empty();
		$("#txtTemplateCalcType").empty();
		if (result.some(r => !r.isWizard) || result.filter(r => r.type.includes('Calc')).length > 1) {
			$("#txtTemplateQA").append('<li>Multiple</li>');
			$("#txtTemplateFilters").append('<li>Multiple</li>');
			$("#txtTemplateCalcType").append('<li>Multiple</li>');
		}
		else
			for (var i = 0; i < result.length; i++) {
				if (result[i].type === 'noData')
					$("#txtTemplateQA").append('<br/><li class="no-data">No data selected</li>');
				else if (result[i].type.includes("QA") || result[i].type.includes("QnA"))
					$("#txtTemplateQA").append('<li>' + result[i].data + '</li>');
				else if (result[i].type.includes("Filter"))
					$("#txtTemplateFilters").append('<li>' + result[i].data + '</li>');
				else if (result[i].type.includes("Calc"))
					$("#txtTemplateCalcType").append('<li>' + result[i].data + '</li>');
			}
	}

	function appendTemplateContent(templateId, templateContent, templateType, overrideSlideSize, isToplineTemplate) {
		var layoutElements = templateContent.layoutElements;
		var layoutSlides = templateContent.layoutSlides;
		var templateVersion = templateContent.version;

		var pageSize = Storyboard.LayoutDesigner.getPageSize();
		var activeSlide = Storyboard.LayoutDesigner.getCurrentSlide();
		var currentPageNo = activeSlide.slideIndex;

		var templateArea = Storyboard.LayoutDesigner.getLayoutElementsAreaHeight(layoutElements);
		var importOffset = Math.floor(templateArea.minTop / pageSize.height);
		var slideOffset = 0;

		var placement = currentPageNo + 1;
		if (templateType === itemTypes.Slide) {
			if (overrideSlideSize && layoutSlides.length > 0)
				Storyboard.LayoutDesigner.addSlide(currentPageNo, placement, "", { width: layoutSlides[0].width, height: layoutSlides[0].height }, Storyboard.LayoutDesigner.selectedMasterLayoutId);
			else
				Storyboard.LayoutDesigner.addSlide(currentPageNo, placement, "", null, Storyboard.LayoutDesigner.selectedMasterLayoutId);

			Storyboard.LayoutDesigner.setCurrentPageNo(++currentPageNo);

			if (Storyboard.LayoutDesigner.enableMasterSlideLayout) {
				var currentSlide = Storyboard.LayoutDesigner.getCurrentSlide();
				if (currentSlide)
					Storyboard.SlidesPanel.addSlideBackgroundFromTemplate(currentSlide.layoutTemplateId)
			}
		} else if (templateType === itemTypes.BackgroundSlide) {
			var bgSlide = Storyboard.LayoutDesigner.getBackgroundSlide();
			var newBgSlide = layoutSlides[0];
			var bgSlideActive;


			if (bgSlide != null) {
				bgSlideActive = $("#" + bgSlide.guid).hasClass("bgSlideActive");
				Storyboard.LayoutDesigner.deleteLayoutSlide(bgSlide);
			}

			newBgSlide.width = pageSize.width;
			newBgSlide.height = pageSize.height;

			Storyboard.LayoutDesigner.addLayoutSlide(newBgSlide);
			Storyboard.LayoutDesigner.setCurrentBackgroundSlide();

			if (bgSlideActive)
				$(".bgSlide", "#layoutArea").addClass("bgSlideActive");
		} else if (templateType === itemTypes.Report) {
			if (!templateVersion || templateVersion < Storyboard.Constants.TemplateVersions.SlidesConcept) {
				// old non-slide template, add one slide of template size
				var reportHeight = templateArea.minTop + templateArea.height;
				Storyboard.LayoutDesigner.addSlide(currentPageNo, placement, "", { width: pageSize.width, height: reportHeight });
			} else { // new one, add all slides
				slideOffset = currentPageNo;
				layoutSlides = layoutSlides.sort(function (a, b) { return a.slideIndex < b.slideIndex ? 1 : -1; });
				for (var s = 0; s < layoutSlides.length; s++) {
					if (layoutSlides[s].isBackground)
						continue;

					var slideTemplateId = isToplineTemplate && layoutSlides[s].layoutTemplateId ? layoutSlides[s].layoutTemplateId : Storyboard.LayoutDesigner.selectedMasterLayoutId;
					if (overrideSlideSize)
						Storyboard.LayoutDesigner.addSlide(currentPageNo, placement, isToplineTemplate ? layoutSlides[s].slideName : "", { width: layoutSlides[s].width, height: layoutSlides[s].height }, slideTemplateId);
					else
						Storyboard.LayoutDesigner.addSlide(currentPageNo, placement, isToplineTemplate ? layoutSlides[s].slideName : "", null, slideTemplateId);

					if (Storyboard.LayoutDesigner.enableMasterSlideLayout) {
						Storyboard.LayoutDesigner.setCurrentPageNo(currentPageNo + 1);
						if (currentSlide)
							Storyboard.SlidesPanel.addSlideBackgroundFromTemplate(currentSlide.layoutTemplateId)
					}
				}
			}
			Storyboard.LayoutDesigner.setCurrentPageNo(++currentPageNo);
		}

		var groups = [];

		if (templateType == itemTypes.Element)
			$(layoutElements).each(function () {
				this.groupId = null;
				this.animate = true;
			});

		if (templateType == itemTypes.BackgroundSlide)
			activeSlide = Storyboard.LayoutDesigner.getBackgroundSlide();
		else
			activeSlide = Storyboard.LayoutDesigner.getCurrentSlide();

		for (var i = 0; i < layoutElements.length; i++) {
			var copy = layoutElements[i];
			var itemType = Storyboard.LayoutDesigner.getLayoutElementType(copy);

			if (templateType === itemTypes.Report && templateVersion >= Storyboard.Constants.TemplateVersions.SlidesConcept) {
				var elementSlide = Storyboard.LayoutDesigner.getSlideByIndex(slideOffset + copy.slideIndex);
				if (!elementSlide)
					continue;

				copy.slideId = elementSlide.slideId;
				copy.slideGuid = elementSlide.guid;
			} else {
				copy.slideId = activeSlide.slideId;
				copy.slideGuid = activeSlide.guid;
			}

			copy.zIndex = Storyboard.LayoutDesigner.getNewZIndex();
			copy.resize = false;
			copy.isImportedTemplate = !isToplineTemplate;
			copy.templateId = templateId;

			if (templateType !== itemTypes.Report && (!templateVersion || templateVersion < Storyboard.Constants.TemplateVersions.SlidesConcept))
				copy.yCoord = copy.yCoord - (importOffset * pageSize.height);

			Storyboard.LayoutDesigner.addLayoutElement(copy, itemType);
			if (copy.groupId != null && groups.indexOf(copy.groupId) < 0)
				groups.push(copy.groupId);
		}

		if (groups.length > 0 && (templateType === itemTypes.Slide || templateType === itemTypes.Report)) {
			var elementsToGroup = [];
			for (var gri = 0; gri < groups.length; gri++)
				elementsToGroup.push($.grep(layoutElements, function (le) { return le.groupId == groups[gri]; }));

			for (gri = 0; gri < elementsToGroup.length; gri++) {
				$(elementsToGroup[gri]).each(function () { this.groupId = null; });
				Storyboard.LayoutDesigner.groupElements(elementsToGroup[gri]);
			}
		} else if (templateType === itemTypes.Group) {
			$(layoutElements).each(function () { this.groupId = null; });
			var newGroup = Storyboard.LayoutDesigner.groupElements(layoutElements);

			if (newGroup) Storyboard.GuiEvents.selectGroup(newGroup.groupId);
		}

		// old non-slide report template: split into slides
		if (templateType === itemTypes.Report && (!templateVersion || templateVersion < Storyboard.Constants.TemplateVersions.SlidesConcept))
			Storyboard.LayoutDesigner.splitSlideIntoSize(activeSlide, pageSize);

		Storyboard.LayoutDesigner.setState(true);
		Storyboard.LayoutDesigner.updateUsageStats();
	}

	function importTemplate(item) {
		if (!item) {
			var selectedTemplateId = $("#templatesList .templateItem.selected").attr("data-id");
			var selectedTemplate = getItemById(selectedTemplateId);
			if (!selectedTemplate) return;
			item = selectedTemplate.item;
		}

		if (item.typeId == itemTypes.BackgroundSlide && Storyboard.LayoutDesigner.getBackgroundSlide()) {
			new DUIwindow2({
				closeButton: false,
				width: 380,
				height: 50,
				html: "Current slide background will be replaced by selected template, do you want to proceed?",
				buttons: [
					{ text: "Cancel", closeWindow: true },
					{ text: "Replace", focused: true, onClick: function () { getTemplateContent(item); } }
				]
			});
		} else
			getTemplateContent(item);
	}

	function getTemplateContent(item) {
		Helpers.perfJSonCall({
			method: "GetTemplateContent",
			data: { templateId: item.id, useSourcePosition: $("#chbUseSourcePosition").is(":checked") },
			successCallback: function (result) {
				if (result) {
					var pageSize = Storyboard.LayoutDesigner.getPageSize();
					var differentSize = false;

					if ((item.typeId == itemTypes.Slide || item.typeId == itemTypes.Report) && result.layoutSlides.length > 0) {
						for (var i = 0 ; i < result.layoutSlides.length; i++)
							if (result.layoutSlides[i].width != pageSize.width || result.layoutSlides[i].height != pageSize.height)
								differentSize = true;
					}

					if (differentSize)
						new DUIwindow2({
							closeButton: false,
							width: 470,
							html: "Imported slide has dimensions different from default slide size used by this report. Which do you want to use?",
							buttons: [{
								text: "Keep original slide size",
								onClick: function () { appendTemplateContent(item.id, result, item.typeId, true); }
							}, {
								text: "Apply slide size used by current report",
								focused: true,
								onClick: function () { appendTemplateContent(item.id, result, item.typeId); }
							}]
						});
					else
						appendTemplateContent(item.id, result, item.typeId);
				}

				Storyboard.GuiEvents.hideTemplatesPanel();
			},
			message: "Loading template...",
			fixCasing: true
		});
	}

	function editTemplateInfoHandler(evt) {
		var templateEl = $(this).closest(".templateItem");
		var enableEditMode = function() {
			$("#hidTemplateTypeId").val("0"); // just editing info
			$("#templatesList .templateItem.selected").removeClass("selected");
			templateEl.addClass("selected");
			editMode = true;
			showHideOperations();
		};


		discardEditsConfirmation(enableEditMode);

		evt.preventDefault();
		evt.stopPropagation();
	}

	function showTemplateInfoTooltip() {
		var templateId = $(this).attr("data-id");
		var info = getItemById(templateId).item;

		var createdInfo = (info.createdDate && info.createdBy ?
			"<div><i>Created on:</i> " + info.createdDate + " <br><i>by:</i> " + info.createdBy + "</div>" :
			"");
		var editedInfo = (info.lastEditDate && info.lastEditedBy ?
			"<div><i>Last edited on:</i> " + info.lastEditDate + " <br><i>by:</i> " + info.lastEditedBy + "</div>" :
			"");
		var goodFor = (info.goodFor ? "<i>Good for</i><p>" + info.goodFor + "</p>" : "");
		var description = (info.description ? "<i>Description</i><p>" + info.description + "</p>" : "");
		var tags = (info.tags ? "<i>Tags</i><p>" + info.tags + "</p>" : "");
		var infoHtml = createdInfo + editedInfo + goodFor + description + tags;
		var tooltipHtml = '<div class="DUITooltipInfo templateItemTooltip">' + infoHtml + '</div>';
		if (templateItemTooltip) templateItemTooltip.destroy();
		$("body > .templateItemTooltip").remove();

		if (infoHtml.length > 0) {
			$("body").append(tooltipHtml);

			templateItemTooltip = new Tether({
				element: $("body .templateItemTooltip").get(0),
				target: this,
				attachment: 'bottom center',
				targetAttachment: 'top center',
				offset: "20px 0",
				addTargetClasses: false,
				constraints: [{
					to: 'window',
					attachment: 'together'
				}]
			});
		}
	}

	function hideTemplateInfoTooltip() {
		if (templateItemTooltip) {
			templateItemTooltip.destroy();
			$(templateItemTooltip.element).remove();
		}
	}

	function zoomThumbnailHandler(evt) {
		var templateItem = $(this).closest(".templateItem");
		var templateId = templateItem.attr("data-id");
		var item = getItemById(templateId).item;
		var templatesCount = $("#templatesList .templateItem").length;

		var getImgUrl = function(item) {
			return "FileHandler.ashx?templateThumbnail=true&tid=" + item.id +
				(item.sourceProjectId ? "&spid=" + item.sourceProjectId : "");
		};

		var getInfoHtml = function(item) {
			var goodFor= (item.goodFor ?"<p><b>Good for: </b>" + item.goodFor + "</p>" : "");
			var description = (item.description ? "<p><b>Description: </b>" + item.description + "</p>" : "");
			var tags= (item.tags ?"<p><b>Tags: </b>" + item.tags + "</p>" : "");

			var infoHTML = "<img id='zoomedTemplateThumbnail' class='blockCenter marginTop20' src='../images/spinner.gif'>" + goodFor + description + tags;

			return infoHTML;
		};

		var dataHtml = function (data) {
			var dataHtml = "<p><b>SAVED DATA</br><div class='size-1-3 calculationTypeData'><span class='dataTypeLabel'>Calculation Type</span><ul class='templateDataList thumbnailData' id='tTemplateCalcType'></ul></div>";
			dataHtml += "<div class='size-1-3 '><span class='dataTypeLabel'>Questions & Answers</span><ul class='templateDataList thumbnailData' id='tTemplateQA'></ul></div>";
			dataHtml += "<div class='size-1-4 '><span class='dataTypeLabel'>Filters</span><ul class='templateDataList thumbnailData' id='tTemplateFilters'></ul></div></p>";
			$(imgDialog.windowEl).find('.DUI-WINDOW-BODY').append(dataHtml);
			$("#tTemplateQA").empty();
			$("#tTemplateFilters").empty();
			$("#tTemplateCalcType").empty();

			if (data.some(r => !r.isWizard) || data.filter(r => r.type.includes('Calc')).length > 1 || ([...new Set(data.map(item => item.dataGroupId))].length > 1 && data.some(r => r.type.startsWith('wc') || r.type.startsWith('rt')))) {
					$("#tTemplateQA").append('<li>Multiple</li>');
					$("#tTemplateFilters").append('<li>Multiple</li>');
					$("#tTemplateCalcType").append('<li>Multiple</li>');
				}
			else {
				for (var i = 0; i < data.length; i++) {
					if (data[i].type === 'noData')
						$("#tTemplateQA").append('<br/><li class="no-data">No data selected</li>');
					else if (data[i].type.includes("QA") || data[i].type.includes("QnA"))
						$("#tTemplateQA").append('<li>' + data[i].data + '</li>');
					else if (data[i].type.includes("Filter"))
						$("#tTemplateFilters").append('<li>' + data[i].data + '</li>');
					else if (data[i].type.includes("Calc"))
						$("#tTemplateCalcType").append('<li>' + data[i].data + '</li>');
				}
			}
		};

		var templateData = function (templateId) {
			Helpers.perfJSonCall({
				data: { templateId: templateId },
				method: "GetTemplateSavedContent",
				successCallback: function (result) {
					if (result.length === 0)
						return;
					else
						dataHtml(result);
				},
				failedCallback: function () {
					evt.stopImmediatePropagation();
					Storyboard.LayoutControls.showMessage(locale.get("Unable to fetch template data."));
				},
				fixCasing: true
			});
		};

		var loadImg = function(item) {
			var zoomedImg = new Image();
			zoomedImg.id = "zoomedTemplateThumbnail";
			zoomedImg.className = "blockCenter marginTop20";
			zoomedImg.style.maxWidth = "100%";

			zoomedImg.onload = function() {
				$(imgDialog.windowEl).css({
					'width': (this.width + 72),
				}).find('#zoomedTemplateThumbnail').replaceWith(this);
			};

			zoomedImg.src = getImgUrl(item);
		};

		var navigateTemplates = function(direction) {
			var newTemplateItem;
			templateItem = $("#templatesList .templateItem[data-id="+ templateId +"]");

			if (direction === "prev") newTemplateItem = templateItem.prev(".templateItem");
			else if (direction === "next") newTemplateItem = templateItem.next(".templateItem");

			if (newTemplateItem && newTemplateItem.length > 0) {
				templateItem = newTemplateItem;
				templateId = templateItem.attr("data-id");
				item = getItemById(templateId).item;

				$(imgDialog.windowEl).find('.DUI-WINDOW-BODY').html(getInfoHtml(item));
				templateData(templateId);
				loadImg(item);
				validateNavigation(templateItem);
			}
		};

		var validateNavigation = function() {
			templateItem = $("#templatesList .templateItem[data-id="+ templateId +"]");
			var index = templateItem.index();

			$("#btnPrevTemplate").toggle(index > 0);
			$("#btnNextTemplate").toggle(index + 1 < templatesCount);
		};

		var dialogButtons = [{ text: "Close", closeWindow: true }];

		var dialogAfterShow = function() {
			loadImg(item);

			$(this.windowEl).find('.DUI-WINDOW-BUTTONS')
				.prepend('<button type="button" id="btnPrevTemplate" class="DUIButtonIcon prevZoomedTemplate" title="Previous">'+
					'<i class="DUI-icon DUI-icon-c-left"></i>'+
					'</button>'+
					'<button type="button" id="btnNextTemplate" class="DUIButtonIcon nextZoomedTemplate" title="Next">'+
					'<i class="DUI-icon DUI-icon-c-right"></i>'+
					'</button>');

			$("#btnPrevTemplate").bind("click", function() { navigateTemplates("prev"); });
			$("#btnNextTemplate").bind("click", function() { navigateTemplates("next"); });

			$(document).bind("keydown.imgDialog", function(evt) {
				switch(evt.which) {
					case 37: // left arrow
						navigateTemplates("prev");
						break;
					case 39: // right arrow
						navigateTemplates("next");
						break;
					default:
						return;
				}
				evt.preventDefault();
			});

			validateNavigation(templateItem);
		};

		var dialogAfterClose = function() {
			$(document).unbind("keydown.imgDialog");
		};

		if (!createMode)
			dialogButtons.push({ text: "Import", focused: true, onClick: function() { importTemplate(item); } });

		var imgDialog = new DUIwindow2({
			html: getInfoHtml(item),
			buttons: dialogButtons,
			cssClass: "zoomedTemplateWindow",
			afterShow: dialogAfterShow,
			afterClose: dialogAfterClose
		});
		templateData(templateItem.attr("data-id"));
		hideTemplateToolsHanlder.apply(templateItem);

		evt.preventDefault();
		evt.stopPropagation();
	}

	function showTemplateToolsHandler() {
		var tooltipDelay = setTimeout(showTemplateInfoTooltip.bind(this), 600);
		var item = getItemById($(this).attr("data-id")).item;

		var menuHtml = "<div class=\"templateItemMenu\">" +
							"<button type=\"button\" class=\"btnThumbnailZoom DUIButtonIcon\" title=\"Zoom tumbnail\">" +
								"<i class=\"DUI-icon DUI-icon--c DUI-icon-search\"></i>" +
							"</button>" + ( createMode || !item.editable ? "" : 
							"<button type=\"button\" class=\"btnMoveTemplate DUIButtonIcon\" title=\"Move Template\">"+
								"<i class=\"DUI-icon DUI-icon--c DUI-icon-shortcuts\"></i>"+
							"</button>") + ( createMode || !item.editable ? "" : 
							"<button type=\"button\" class=\"btnEditTemplateInfo DUIButtonIcon\" title=\"Edit Template Info\">"+
								"<i class=\"DUI-icon DUI-icon--c DUI-icon-edit\"></i>"+
							"</button>") + (createMode || !item.editable ? "" :
							"<button type=\"button\" class=\"btnDeleteTemplate DUIButtonIcon\" title=\"Delete Template\">"+
								"<i class=\"DUI-icon DUI-icon--c DUI-icon-trash\"></i>"+
							"</button>") +
						"</div>";

		$(this).append(menuHtml).data("tooltipDelay", tooltipDelay);
	}

	function hideTemplateToolsHanlder() {
		var tooltipDelay = $(this).data("tooltipDelay");
		if (tooltipDelay) {
			clearTimeout(tooltipDelay);
			$(this).removeData("tooltipDelay");
		}
		hideTemplateInfoTooltip();
		$(this).find(".templateItemMenu, button").remove();
	}

	function createTemplate(typeId, elementGuid) {
		var templateElements = [];
		var contentElements = [];
		switch (typeId) {
			case itemTypes.Element:
				var elem = Storyboard.LayoutDesigner.getLayoutElementByGuid(elementGuid);
				if (elem)
					templateElements.push(elem);
				break;
			case itemTypes.Group:
				var groupId = Storyboard.LayoutDesigner.getSelectedGroupId();
				if (groupId <= 0)
					break;
				templateElements = Storyboard.LayoutDesigner.getLayoutElementsGroup(groupId).layoutElements;
				break;
			case itemTypes.Slide:
				var currentPageNo = Storyboard.LayoutDesigner.getCurrentPageNo();
				var layoutElements = Storyboard.LayoutDesigner.getLayoutElements();
				templateElements = $.grep(layoutElements, function (le) {
					return Helpers.getLayoutElementSlideIndex(le) == currentPageNo;
				});
				break;
			case itemTypes.Report:
				showDataSectionMultiple();
				break;
			default:
				break;
		}
		if (templateElements.length > 0) {
			for (var i = 0; i < templateElements.length; i++) {
				var leItemTypes = Storyboard.Constants.itemTypes;
				var contentItem = Storyboard.LayoutDesigner.getElementItemByType(leItemTypes.CHART, leItemTypes.SIMPLETABLE, leItemTypes.DYNAMICICONSHAPE, leItemTypes.WORDCLOUD, leItemTypes.RESPONDENTTABLE, templateElements[i]);
				if (contentItem)
					contentElements.push(templateElements[i]);
			}
			if (contentElements.length > 1) {
				showDataSectionMultiple();
			}
			else if (contentElements.length === 1) {
				getContent(contentElements[0].layoutElementItems[0].elementItemId, contentElements[0].layoutElementItems[0].itemType, false, null);
				$("#templatesLibraryNewItemDataContent").show();
			}
			else {
				hideSavedDataSection();
			}
		}
		else if (typeId != itemTypes.Report)
			hideSavedDataSection();

		$("#hidTemplateTypeId").val(typeId);
		$("#hidElementGuid").val(elementGuid || "");
		$("#txtTemplateName, #txtTemplateTags, #txtTemplateDescription, #txtTemplateGoodFor").val("");
		createMode = true;
		editMode = false;
		setupPanel();
	}

	function showDataSectionMultiple() {
		$("#templatesLibraryNewItemDataContent").show();
		$("#txtTemplateCalcType").empty();
		$("#txtTemplateQA").empty();
		$("#txtTemplateFilters").empty();
		$("#txtTemplateCalcType").append('<li>Multiple</li>');
		$("#txtTemplateQA").append('<li>Multiple</li>');
		$("#txtTemplateFilters").append('<li>Multiple</li>');
	}

	function deleteTemplate(templateId) {
		new DUIwindow2({
			closeButton: false,
			height: 30,
			html: "Do you really want to delete this template?",
			buttons: [
				{ text: "Cancel", closeWindow: true },
				{ text: "Delete", focused: true, onClick: function() { deleteItem(templateId); } }
			]
		});
	}

	function deleteTemplateHandler(evt) {
		var templateId = parseInt($(this).closest(".templateItem").attr("data-id"), 10);
		var discardEditsConfirmed = function() {
			deleteTemplate(templateId);
		};

		if (!isNaN(templateId))
			discardEditsConfirmation(discardEditsConfirmed);

		evt.preventDefault();
		evt.stopPropagation();
	}

	function editOrImportTemplate() {
		createMode = editMode = false;
		setupPanel();
	}

	// --- end Template operations  ---

	sb.TemplatesLibrary.editOrImportTemplate = editOrImportTemplate;
	sb.TemplatesLibrary.appendTemplateContent = appendTemplateContent;
	sb.TemplatesLibrary.createTemplate = createTemplate;
	sb.TemplatesLibrary.saveTemplateContent = saveTemplateContent;
	sb.TemplatesLibrary.importTemplate = importTemplate;
	sb.TemplatesLibrary.addFolder = addFolder;
	sb.TemplatesLibrary.chooseTemplateType = chooseTemplateType;
})(window.Storyboard = (window.Storyboard || {}));
